import { Component, Input } from '@angular/core';
import { CpdEntry } from '../../../model/CpdEntry';
@Component({
    selector: 'app-cpd-entry-annotations',
    templateUrl: './cpdEntryAnnotations.component.html',
    standalone: false
})
export class CpdEntryAnnotationsComponent {

  @Input() cpdEntry: CpdEntry;

}
